import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "menu", "userButton", "userMenu"]

  connect() {
    console.log("Mobile menu controller connected")
    // Close dropdowns when clicking outside
    document.addEventListener('click', this.handleClickOutside.bind(this))
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside.bind(this))
  }

  toggle() {
    const expanded = this.buttonTarget.getAttribute('aria-expanded') === 'true'
    this.buttonTarget.setAttribute('aria-expanded', !expanded)
    this.menuTarget.classList.toggle('hidden')
  }

  toggleUserDropdown() {
    const expanded = this.userButtonTarget.getAttribute('aria-expanded') === 'true'
    this.userButtonTarget.setAttribute('aria-expanded', !expanded)
    this.userMenuTarget.classList.toggle('hidden')
  }

  hideUserDropdown() {
    this.userMenuTarget.classList.add('hidden')
    this.userButtonTarget.setAttribute('aria-expanded', 'false')
  }

  handleClickOutside(event) {
    // Only handle user dropdown outside clicks if user dropdown targets exist
    if (this.hasUserButtonTarget && this.hasUserMenuTarget) {
      const userDropdownContainer = this.userButtonTarget.closest('.relative')
      if (userDropdownContainer && !userDropdownContainer.contains(event.target)) {
        this.hideUserDropdown()
      }
    }
  }
} 